import { action } from '@ember/object';
import { service } from '@ember/service';
import StrategyCalculation from 'scaleflow/components/strategy/StrategyCalculation';
export default class RoadmapRoadmapVisualisationIndexComponent extends StrategyCalculation {
  @service intl;
  @service betaToggle;

  get initiatives() {
    return this.args.initiatives ?? [];
  }

  get visionInitiatives() {
    return this.initiatives.filter(
      (item) => item?.source?.toLowerCase() === 'vision',
    );
  }

  get customerRequestInitiatives() {
    return this.initiatives.filter(
      (item) => item?.source?.toLowerCase() === 'customer request current',
    );
  }

  get operationsInitiatives() {
    return this.initiatives.filter(
      (item) => item?.source?.toLowerCase() === 'operations and maintenance',
    );
  }

  get scenario() {
    return this.args.scenario;
  }

  generateRangeBoxes(scenario, source) {
    const lower_limit = this.calculateInitiativesLimit(
      scenario,
      source,
      'upper',
    );
    const upper_limit = this.calculateInitiativesLimit(
      scenario,
      source,
      'lower',
    );
    const interval_value = Math.ceil(
      this.calculateInterval(upper_limit, lower_limit),
    );
    const [, upper_advised_limit] = this.calculateAdvisedRange(
      lower_limit,
      upper_limit,
      true,
    );

    let initiatives_counter = 0;

    const must_fill_boxes = new Array(lower_limit).fill('-').map(() => {
      initiatives_counter++;
      return { color: 'bg-green-600', type: 'required' };
    });
    let should_fill_boxes = [];
    new Array(this.divisions).fill('-').forEach(() => {
      const arr = new Array(interval_value).fill('-').map(() => {
        initiatives_counter++;
        const color =
          initiatives_counter > upper_advised_limit
            ? 'bg-yellow-500'
            : 'bg-green-400';
        return { color, type: 'optional' };
      });
      should_fill_boxes = [...should_fill_boxes, ...arr];
    });
    const boxes = [...must_fill_boxes, ...should_fill_boxes];
    return boxes;
  }

  get visionBucketConfig() {
    return {
      total_capacity: this.calculatePwCapacity(
        this.scenario,
        'vision',
        true,
      )?.toFixed(1),
      title: this.intl.t('source-options.vision'),
      initiatives: this.visionInitiatives,
      boxes: this.generateRangeBoxes(this.scenario, 'vision'),
      source: 'VISION',
      test_id: 'vision',
    };
  }

  get customerRequestBucketConfig() {
    return {
      total_capacity: this.calculatePwCapacity(
        this.scenario,
        'customer',
        true,
      )?.toFixed(1),
      title: this.intl.t('source-options.customer-request'),
      initiatives: this.customerRequestInitiatives,
      boxes: this.generateRangeBoxes(this.scenario, 'customer'),
      source: 'CUSTOMER REQUEST CURRENT',
      test_id: 'customer-led',
    };
  }

  get operationsBucketConfig() {
    return {
      total_capacity: this.calculatePwCapacity(
        this.scenario,
        'operations',
        true,
      )?.toFixed(1),
      title: this.intl.t('source-options.operations'),
      initiatives: this.operationsInitiatives,
      boxes: this.generateRangeBoxes(this.scenario, 'operations'),
      source: 'OPERATIONS AND MAINTENANCE',
      test_id: 'operations',
    };
  }

  @action
  propagateInitiative(e) {
    this.args.onInitiativeSelect(e);
  }
}
